var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.587 11.596A7.402 7.402 0 0 0 8 19.026a7.402 7.402 0 0 0 7.413-7.43A7.358 7.358 0 0 0 8.025 4.2c-.432 0-.855.042-1.22.116l2.008-1.983a.799.799 0 0 0 .225-.557.8.8 0 0 0-.789-.813.745.745 0 0 0-.573.24L4.273 4.666a.852.852 0 0 0-.257.598c0 .224.083.423.257.597l3.403 3.437c.141.15.332.224.573.224.44 0 .789-.349.789-.805a.767.767 0 0 0-.233-.548L6.547 5.927a7.18 7.18 0 0 1 1.478-.133c3.212 0 5.76 2.565 5.76 5.802A5.773 5.773 0 0 1 8 17.398a5.773 5.773 0 0 1-5.786-5.802c0-.49-.315-.838-.797-.838-.49 0-.83.348-.83.838Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrow);
export default __webpack_public_path__ + "static/media/circleArrow.298f11585b95005b8be2c1b2e20d6601.svg";
export { ForwardRef as ReactComponent };